module.exports = __webpack_public_path__ + "assets/img/sky.e1a704f2.webp";